import {  useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getEmployeRequests } from "../../../../../MyApi/hr/employerequests";

import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import SingleEmployeRequests from "../employerequestsSalary";
import SubFilterEmployeRequests from "../../subfilteremployrequests";
import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";

import classes from "./employrequestsDataTable.module.css";

const EmployeRequestsDataTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sb_branch_id, setSbBranchId] = useState("");
  const [sb_employe_id, setSbEmployeId] = useState("");
  const [sb_request_id, setSbRequestId] = useState("");
  const [date_from, setDateFrom] = useState("");
  const [date_to, setDateTo] = useState("");
  const [status, setStatus] = useState("");
  const { data, isLoading, refetch, error } = useQuery(
    [
      "getEmployRequests",
      currentPage,
      sb_employe_id,
      sb_request_id,
      sb_branch_id,
      date_from,
      date_to,
      status,
    ],
    () =>
      getEmployeRequests(
        currentPage,
        sb_employe_id,
        sb_request_id,
        sb_branch_id,
        date_from,
        date_to,
        status
      )
  );

  const { t } = useTranslation();

  const totalItems = data?.total;
  const employerequests = data?.data || [];
  const responeMessage = data?.message;



  if (error) {
    return <ErrorMessage error={error} />;
  }
  return (
    <div className="container-fluid">
      <SubFilterEmployeRequests
        setDateFrom={setDateFrom}
        setStatus={setStatus}
        setDateTo={setDateTo}
        branchId={sb_branch_id}
        setSbBranchId={setSbBranchId}
        setSbEmployeId={setSbEmployeId}
        setSbRequestId={setSbRequestId}
        t={t}
      />
     
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
             { employerequests.length === 0 ?<NoData responeMessage={responeMessage}/> :
             <> {!data ? (
              <div>no data available </div>
            ) : (
              <> <div class="card">
        <table className="table-responsive-sm table table-striped table-hover">
          <thead >
            <th>#</th>
            <th>{t("Name")}</th>
            <th> {t("Employee")}</th>
            <th>{t("Note")}</th>
            <th>{t("DateTo")}</th>
            <th>{t("Status")}</th>
          </thead>
          <tbody>
                {employerequests.map((requests) => (
                  <SingleEmployeRequests
                    key={requests.id}
                    requests={requests}
                    classes={classes}
                    refetch={refetch}
                  />
                ))}  </tbody>
        </table>
      </div>
              </>
            )}</>
               }
              </>
            )}
        
      <div className="d-flex justify-content-center mb-3">
        <PagnationComponent
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          totalItems={totalItems}
        />
      </div>
    </div>
  );
};

export default EmployeRequestsDataTable;
